var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pdf-viewer-main"},[(_vm.$vuetify.breakpoint.mobile)?_c('PDFViewerMobile',{attrs:{"url":_vm.url,"base64":_vm.base64,"filename":_vm.filename}}):(_vm.base64)?_c('iframe',{attrs:{"src":`data:application/pdf;base64,${_vm.base64}`,"type":"application/pdf"}}):_c('iframe',{attrs:{"src":_vm.url,"type":"application/pdf"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }